<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import { LANGUAGES } from '@/constants'
import { setLocale } from '@/services/localStorage'

const { locale } = useI18n({ useScope: 'global' })
const menu = ref(false)

async function changeLocale(code: string) {
  setLocale(code)
  locale.value = code
  menu.value = false
}
</script>

<template>
  <v-menu v-model="menu">
    <template #activator="{ props }">
      <v-btn
        color="white"
        variant="text"
        v-bind="props"
      >
        <Icon
          :icon="locale === 'ru' ? 'circle-flags:ru' : 'circle-flags:us'"
          class="mr-2"
          :height="22"
        />
        {{ locale.toUpperCase() }}
      </v-btn>
    </template>
    <v-list slim>
      <v-list-item
        v-for="item in LANGUAGES"
        :key="item.value"
        min-height="40"
        @click="changeLocale(item.value)"
      >
        <template #prepend>
          <Icon
            v-if="item.icon"
            :icon="item.icon"
            :height="22"
            class="mr-2"
          />
        </template>
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
